import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26805e3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "welcome-cards pb-2 pt-3" }
const _hoisted_2 = { class: "welcome-card-item rounded position-relative" }
const _hoisted_3 = { class: "text-white card-title position-absolute" }
const _hoisted_4 = { class: "img-wrapper" }
const _hoisted_5 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titles, (item) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: `/mods/${item.link}?page=1`,
          class: "position-absolute welcome-card-link"
        }, null, 8, ["to"]),
        _createElementVNode("h5", _hoisted_3, _toDisplayString(item.title), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            class: "item-pic",
            src: _ctx.itemImage(item.link),
            alt: item.link
          }, null, 8, _hoisted_5)
        ])
      ]))
    }), 256))
  ]))
}